document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
  const menu = document.querySelector('[data-mobile-menu-drawer]');
  const menuClose = document.querySelector('[data-mobile-menu-close]');
  const overlay = document.querySelector('[data-mobile-menu-overlay]');
  let previousFocus = null;

  const openMenu = () => {
    if (!menu) return;
    previousFocus = document.activeElement;
    menu.classList.add('is-open');
    overlay?.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    menuToggle?.setAttribute('aria-expanded', 'true');
    document.body.classList.add('is-locked');
    menu.querySelector('a, button')?.focus();
  };

  const closeMenu = () => {
    if (!menu) return;
    menu.classList.remove('is-open');
    overlay?.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    menuToggle?.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('is-locked');
    previousFocus?.focus();
  };

  menuToggle?.addEventListener('click', openMenu);
  menuClose?.addEventListener('click', closeMenu);
  overlay?.addEventListener('click', closeMenu);
  menu?.querySelectorAll('[data-mobile-nav-link]').forEach((link) => link.addEventListener('click', closeMenu));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menu?.classList.contains('is-open')) closeMenu();
  });

  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', anchor.getAttribute('href'));
    });
  });

  const faqItems = document.querySelectorAll('.faq-item details');
  faqItems.forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;
      faqItems.forEach((other) => {
        if (other !== item) other.removeAttribute('open');
      });
    });
  });
});
